import { Controller } from "@hotwired/stimulus"
import { setHidden } from "../lib/display_toggle"

// Toggles password input between obscured/visible.
// Usage:
//   data-controller="password-visibility"
//     div.password-visibility
//       input[type=password] data-password-visibility-target="input"
//       button[type=button] data-action="click->password-visibility#toggle"
//         aria-pressed="false" data-password-visibility-target="button"
//         i.password-visibility-icon-hidden  data-password-visibility-target="iconHidden"
//         i.password-visibility-icon-visible data-password-visibility-target="iconVisible" class=d-none
//
// The button target receives `aria-pressed` ("true" when password is visible,
// "false" when obscured) so screen-reader users hear the current state on
// every focus, not just a static "show or hide password" label.
export default class extends Controller {
  static targets = ["input", "iconHidden", "iconVisible", "button"]

  toggle(event) {
    event.preventDefault()
    if (!this.hasInputTarget) return
    const showing = this.inputTarget.type === "text"
    this.inputTarget.type = showing ? "password" : "text"
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-pressed", String(!showing))
    }
    if (this.hasIconHiddenTarget) setHidden(this.iconHiddenTarget, !showing)
    if (this.hasIconVisibleTarget) setHidden(this.iconVisibleTarget, showing)
  }
}
